import shopPerformance from '@/api/report/shop-performance'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
    ...baseState,
    dateRange: [
        moment().format('DD-MM-YYYY'),
        moment().format('DD-MM-YYYY')
    ],
    shopIds: []
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_DATE_RANGE(state, dateRange) {
        state.dateRange = dateRange
    },
    SET_SHOP_IDS(state, shopIds) {
        state.shopIds = shopIds
    }
}

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.currentPage,
                perPage: context.state.pagination.perPage,
                date_range: context.state.dateRange,
                shop_ids: context.state.shopIds
            },
            attributes
        )

        return shopPerformance.viewData({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    }
}
